import React from 'react'
import { Link } from 'gatsby'
import PATHS from 'paths'

export const QUESTIONS_COPY = [
  {
    question: 'What is a will, and why do I need one?',
    answer:
      'A will is a legal document that states what you want to happen to everything you own when you die. It includes things like money, property, investments and possessions, which legal professionals often call your assets. All your assets lumped together are called your estate. If you have children under 18 years old, making a will also allows you to say who you would like their legal guardian(s) to be.',
  },
  {
    question: 'What happens if I die without making a will?',
    answer: (
      <>
        If you die before making a will, the government will follow the{' '}
        <Link to={`${PATHS.GENERAL.ARTICLES}/what-are-the-rules-of-intestacy`}>
          rules of intestacy
        </Link>
        , a set of guidelines that decides who gets your assets. But these rules
        are over 100 years old, so do not consider modern family dynamics like
        unmarried couples, step-children or your personal preference. If you’ve
        got children under 18, and have not appointed a legal guardian, social
        services and/or the courts can make decisions about who takes care of
        them.
      </>
    ),
  },
  {
    question: 'What gifts can I leave in a will?',
    answer:
      'You can leave different types of gifts in your will, from specific items to a percentage of your estate. In the UK, over a third of us choose to leave a gift to charity in addition to gifts for family and friends. A ‘specific gift’ is (as the name suggests) an individual gift like jewellery, artwork and furniture. A ‘residuary gift’ is given as a percentage of your estate. Sometimes, a residuary estate may be the only gift left in a will and the recipient will gain control of the whole estate. In other cases, people choose to leave a percentage to different charities or individuals. Leaving a percentage of your estate rather than a specific sum of money is a simple way to make sure that the value of your gift keeps up with inflation.',
  },
  {
    question: 'Can I include funeral wishes in my will?',
    answer: (
      <>
        Yes, you can include funeral wishes in your will, and there’s a section
        for sharing them in our will writing service. You might want to specify
        whether you want a burial or cremation and how you’d like people to
        remember you. It’s helpful to leave your wishes, so your family knows
        what you want.{' '}
        <Link to={PATHS.CREMATION.FUNERAL_PLANS}>
          Pre-paying for a cremation
        </Link>{' '}
        is another excellent way of taking care of your family in advance.
      </>
    ),
  },
]

export const GUIDES_COPY = {
  title: 'Helpful articles when writing a will',
  readMore: 'Read more',
  articles: [
    {
      illustration: 'executor-of-will',
      name: 'What is an executor of a will and how do you appoint them?',
      description:
        'One of the most important parts of writing a will is choosing your executors. Here, we’ll cover who can be an executor, what they do and why they’re so important.',
      article: 'what-is-an-executor-of-a-will-and-how-do-you-appoint-them',
    },
    {
      illustration: 'blob-signing-will-thumbs-up',
      name: 'Who can witness and sign a will?',
      description:
        'A will can be witnessed and signed by anyone over the age of 18 – such as a neighbour, friend or colleague. The only rules are that they can’t be a beneficiary of your will, married to a beneficiary, or blind.',
      article: 'who-can-witness-and-sign-a-will',
    },
    {
      illustration: 'couples-signing-wills-2',
      name: 'What is a mirror will and do I need one?',
      description:
        'When couples in the UK think about writing a will, the term ‘mirror will’ often springs to mind. But is it really the best option for you and your partner?',
      article: 'what-is-a-mirror-will-and-do-i-need-one',
    },
  ],
  freeGuide: {
    text: 'Read our free guide',
    link: `${PATHS.GENERAL.CONTENT_HUB}/how-to-make-a-will`,
  },
}
